import { useNoOrgExperience } from '@townsquare/org-context';
import { createRouterSelector } from '@townsquare/router/createRouterSelector';
import { HomepageRoute, HomepageRoutes } from '@townsquare/router/route-types';
import { useNoWorkspaceExperience } from '@townsquare/workspace-store';

import { noWorkspaceRoutes, routes } from './routes';

export const useRoute: (args_0: void) => HomepageRoute = createRouterSelector<HomepageRoute>(
	o => o.route as HomepageRoute,
);

export const useProjectsRoutes = (): HomepageRoutes => {
	const noOrgExperience = useNoOrgExperience();
	const noWorkspaceExperience = useNoWorkspaceExperience();

	if (noOrgExperience || noWorkspaceExperience) {
		return noWorkspaceRoutes;
	}

	return routes;
};
